// extracted by mini-css-extract-plugin
export default {"wrapper":"iC-z","viewport":"jC-z","container":"kC-z","slide":"lC-z"};